import { createContext, type Dispatch, type SetStateAction } from 'react';

import type { IconSet, Theme } from '../../themes/types';

export type SuiThemeContext = {
  iconSet: IconSet;
  useCustomScrollbars?: boolean; //TODO: Remove prop when Chrome has a floating scrollbar like every other browser
  theme?: Theme;
  setTheme: Dispatch<SetStateAction<Theme>>;
  colorScheme: Exclude<Theme, 'system'>;
};

export const SuiThemeContext = createContext<SuiThemeContext>({} as SuiThemeContext);
